import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'firstError',
    standalone: false
})
export class CheckErrorPipe implements PipeTransform{
    transform(errorObject){
        let firstError = '';
        
        Object.keys(errorObject).some(error=>{            
            if(errorObject[error]){            
                firstError = error;
                return true;
            }
        });  
        if('required' in errorObject){
            if(errorObject.required){                
                firstError = 'required';
            }
        }
        return firstError;
    }
}